import React, { useEffect, useState } from 'react';
import { Card, Col, Modal, ModalBody, ModalFooter, ModalHeader,Spinner } from 'reactstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader';
import CommonTable from '../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable';
import { medicalRep } from '../../../../Data/Tables/ReactstrapTables/BasicTables';
import { baseUrl } from '../../../../Utils/Baseurl/Baseurl';
import { Btn } from '../../../../AbstractElements';
import { toast } from 'react-toastify';
import api from "../../../../services/api";

interface MedicalRep {
  id: number;
  name: string;
  companyId: number;
  departmentId: number;
  contactno: string;
  createdAt: string;
  updatedAt: string;
  userId: number;
  Company?: { companyname: string };
  Department?: { departmentname: string };
  user?: { email: string; disablestatus: number };
}

export default function MedicalRepTable() {
  const [medicalReps, setMedicalReps] = useState<MedicalRep[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>(''); // Add searchQuery state
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [selectedUserEmail, setSelectedUserEmail] = useState<string | null>(null);
  const [newStatus, setNewStatus] = useState<number | null>(null);
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false);


  useEffect(() => {
    fetchMedicalReps();
  }, []);

  const fetchMedicalReps = async () => {
    try {
      const response = await api.get(`${baseUrl}medicalrep/getAllmedicalrep`);
      setMedicalReps(response.data);
    } catch (error) {
      console.error('Error fetching medical representatives:', error);
    }
  };

  const handleConfirm = (userId: number, status: number, email: string) => {
    setSelectedUserId(userId);
    setNewStatus(status);
    setModalOpen(true);
    setSelectedUserEmail(email);
  };

  const updateUserStatus = async () => {
    setLoading(true);
    if (selectedUserId !== null && newStatus !== null && selectedUserEmail) {
      setLoading(true);
      try {
        await api.put(`${baseUrl}user/disable`, {
          userId: selectedUserId,
          disablestatus: newStatus,
          email: selectedUserEmail
        });
  
        toast.success(`User ${newStatus === 1 ? 'blocked' : 'unblocked'} successfully.`);
        fetchMedicalReps();
      } catch (error) {
        console.error('Error updating user status:', error);
        toast.error('Failed to update user status.');
      } finally {
        setLoading(false);
        setModalOpen(false);
      }

    } else {
      toast.error("User ID, status, and email are required.");
    }
  };
  

  // Filter medicalReps based on search query
  const filteredReps = medicalReps.filter(rep =>
    rep.name.toLowerCase().startsWith(searchQuery.toLowerCase())
  );

  return (

    <>
    <Modal isOpen={loading} centered>
  <ModalBody className="text-center">
    <Spinner color="primary" />
    <p className="mt-2">Please wait...</p>
  </ModalBody>
</Modal>

    <Col sm={12}>
      <Card>
        <CommonCardHeader title="Medical Representative Details" />


        {/* Search Box */}
        <div className="mb-3">
          <div className="row">
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <CommonTable headData={medicalRep} headRowClass="border-bottom-secondary border-top-0">
            {filteredReps.length > 0 ? (
              filteredReps.map((rep: MedicalRep, index: number) => (
                <tr key={rep.id}>
                  <td>{index + 1}</td>
                  <td>{rep.name}</td>
                  <td>{rep.Company?.companyname || 'N/A'}</td>
                  <td>{rep.Department?.departmentname || 'N/A'}</td>
                  <td>
                    <span className={rep.user?.disablestatus === 0 ? 'text-success' : 'text-danger'}>
                      {rep.user?.disablestatus === 0 ? 'Active' : 'Blocked'}
                    </span>
                  </td>
                  <td>
                    {rep.user?.disablestatus === 0 ? (
                      <Btn onClick={() => handleConfirm(rep.userId, 1, rep.user?.email || '')}>Block</Btn>
                    ) : (
                      <Btn onClick={() => handleConfirm(rep.userId, 0, rep.user?.email || '')}>Unblock</Btn>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>No data available</td>
              </tr>
            )}
          </CommonTable>
        </div>
      </Card>

      {/* Confirmation Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Confirm {newStatus === 1 ? 'Blocking' : 'Unblocking'}
        </ModalHeader>
        <ModalBody>
          Are you sure you want to {newStatus === 1 ? 'block' : 'unblock'} this user?
        </ModalBody>
        <ModalFooter>
          <Btn color="danger" onClick={updateUserStatus}>
            Yes, {newStatus === 1 ? 'Block' : 'Unblock'}
          </Btn>
          <Btn color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Btn>
        </ModalFooter>
      </Modal>
    </Col>
    </>

  );
}
